import React from "react"
import PropTypes from "prop-types"
import { VehicleServiceSummary } from "components"
import { Section } from "AtomicComponents"
import COLOR_PALETTE from "constants/color-palette"
import { gtmMyMazda2ActionTypes } from "store/gtm-events"

const MyMazdaServiceSummaryBlock = props => (
  <Section
    padding
    backgroundColor={props.expandDetails ? COLOR_PALETTE.WHITE : COLOR_PALETTE.GRAY_LIGHTER}>
    <VehicleServiceSummary gtmOnClickContinue={createGtmAction.clickContinue} {...props} />
  </Section>
)

const createGtmAction = {
  clickContinue: ({ buttonText }) => ({
    gtmID: gtmMyMazda2ActionTypes.CALCULATOR_CLICK,
    gtmPayload: { buttonText }
  })
}

MyMazdaServiceSummaryBlock.propTypes = {
  expandDetails: PropTypes.bool
}

export default MyMazdaServiceSummaryBlock



// WEBPACK FOOTER //
// ./src/blocks/mymazda/service/summary.jsx